import { ICreateSendShipmentInfoPatch } from '../../../types/createSendShipmentInfo';

export const PATCH_CS_SHIPMENT_INFO = 'PATCH_CS_SHIPMENT_INFO';
export const RESET_CS_SHIPMENT_INFO = 'RESET_CS_SHIPMENT_INFO';

export const patchCsShipmentInfo = (payload: ICreateSendShipmentInfoPatch) => ({
  type: PATCH_CS_SHIPMENT_INFO,
  payload,
});

export const resetCsShipmentInfo = () => ({
  type: RESET_CS_SHIPMENT_INFO,
});
